export const enum ReloadTimes {
    SPEED_RELOAD = 1,
    FAST_RELOAD = 5,
    MEDIUM_RELOAD = 15,
    LONG_RELOAD = 30,
}

export const AvailableLanguages = [
    { label: 'English', value: 'en', flag: 'gb' },
    { label: 'Français', value: 'fr', flag: 'fr' },
    { label: 'Deutsch', value: 'de', flag: 'de' },
];